import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

interface CloseConfirmationDialogueProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}

const CloseConfirmationDialogue: React.FC<CloseConfirmationDialogueProps> = ({
  open,
  title = "Confirm Action",
  message,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          Are you sure you want to exit this form?
        </DialogContentText>
        <DialogContentText id="confirm-dialog-description">
          If you click 'Close' then you will lose changes in the form.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button> */}
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
          
        >
          Cancel
        </button>
        {/* <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          variant="contained"
          color="error"
        >
          Close
        </Button> */}
        <button
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-indigo-500 dark:hover:bg-indigo-400"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseConfirmationDialogue;
